export default {
  elevation1: { boxShadow: '0px 2px 4px rgba(108, 133, 154, 0.111781)' },
  rounded: { borderRadius: 6 },
};
